import React from 'react'
import { GetStaticPaths, GetStaticProps } from 'next'
import { ParsedUrlQuery } from 'querystring'
import { useRouter } from 'next/router'
import Image from 'next/image'

import { Course, ICourse } from '@/components/course'
import { FileProvider } from '../../lib/files'
import ArticleSEO from '@/components/blog/article_seo'
import Config from '../../site.config'
import { Social } from '@/components/social'
import { ContactHome } from '@/components/contact'
import gradientImg from '../../public/images/gradient_light.jpg'
import Meta from '@/components/Meta'

interface IProps {
  data: ICourse
}

const SingleCourse = (props: IProps) => {
  const router = useRouter()
  const pid = router.query.single_post
  const { data } = props

  const p = router.asPath.slice(1)
  const canonicalURL = `${Config.site.URL}/${p}`.split('?')[0]

  return (
    <div>
      <Meta title={`${pid}`} canonicalURL={canonicalURL} />
      <ArticleSEO metadata={data.metadata} />
      <div className='relative pt-[5.5rem]'>
        {/* <!-- Post --> */}
        <section className='py-16 md:py-24'>
          <picture className='pointer-events-none absolute inset-0 -z-10 dark:hidden'>
            <Image
              src={gradientImg}
              alt='gradient'
              priority={true}
              className='h-full w-full'
            />
          </picture>
          <div className='px-5 md:px-12 lg:px-40 p-2'>
            <Course course={data} />
            <Social url={router.asPath} title={data.metadata.title} />
          </div>
        </section>
      </div>
      <ContactHome />
    </div>
  )
}

export default SingleCourse

export const getStaticPaths: GetStaticPaths = async () => {
  const provider = new FileProvider()
  const courseList = provider.getCourses()

  const paths = courseList.map((file: ICourse) => ({
    params: { single_course: file.slug },
  }))

  return { paths, fallback: false }
}

interface IParams extends ParsedUrlQuery {
  single_course: string
}

export const getStaticProps: GetStaticProps = async (context) => {
  const provider = new FileProvider()
  const postList = provider.getCourses()

  const { single_course } = context.params as IParams

  const courseData = postList.find((item) => {
    return item.slug == single_course
  })

  return { props: { data: courseData } }
}
